// extracted by mini-css-extract-plugin
export var copy = "RichContent-module--copy--82892";
export var table = "RichContent-module--table--1e120";
export var tableCell = "RichContent-module--tableCell--cb256";
export var tableHeaderCell = "RichContent-module--tableHeaderCell--1624f";
export var tableWrapper = "RichContent-module--tableWrapper--900c0";
export var title = "RichContent-module--title--a1a8a";